import { useMemo } from 'react'
import { Box } from '@mui/material'
import { buildBrokenStepPaths } from '@/components/Settings/connectionUsageSparklinePaths'
import { getConnectionUsageLast7Days } from '@/components/Settings/connectionUsageLast7Days'
import styles from '@/components/Settings/ConnectionUsageSparkline.module.scss'

/** @param {{ connectionId: string, label?: string }} props */
export default function ConnectionUsageSparkline({ connectionId, label = 'Connection' }) {
  const values = useMemo(() => getConnectionUsageLast7Days(connectionId), [connectionId])
  const { segments, areas, w, h } = useMemo(() => buildBrokenStepPaths(values), [values])
  const ariaLabel = `Usage over the last 7 days for ${label}`

  return (
    <Box className={styles.wrap} title={ariaLabel}>
      <Box className={styles.chart}>
        <svg className={styles.svg} width={w} height={h} viewBox={`0 0 ${w} ${h}`} role="img" aria-label={ariaLabel}>
          {areas.map((d, i) => (
            <path key={`area-${i}`} className={styles.area} d={d} />
          ))}
          {segments.map((d, i) => (
            <path key={`line-${i}`} className={styles.line} d={d} />
          ))}
        </svg>
      </Box>
    </Box>
  )
}
